import React, { useState } from "react";
import { injectIntl } from "react-intl";
import RadioGroupInput from "../RadioButtonGroup";
import TableIcon from "../../assets/images/icons/table";
import GridIcon from "../../assets/images/icons/grid";
import BasicTable from "./table";
import PaginationComponent from "../Pagination";
import "./style.scss";
const TableGridView = ({
  title,
  table,
  gridView,
  pagination,
  Form,
  programs,
  defaultView,
}) => {
  const [view, setView] = useState(defaultView || "list");
  const handleChange = (e, value) => {
    setView(value);
  };
  const options = [
    {
      icon: <GridIcon active={false} />,
      checkedICon: <GridIcon fill="#6a2a53" active={true} height={25} />,
      value: "grid",
    },
    {
      icon: <TableIcon active={false} />,
      checkedICon: <TableIcon fill="#6a2a53" active={true} height={24} />,
      value: "list",
    },
  ];
  const lang = localStorage.getItem("lang");
  return (
    <div className="h-100">
      {title && (<div className="row mb-3" style={{ alignItems: 'center' }}>
        <div className={title === "Payments" ? 'col-md-12' : 'col-md-8' }>
          {Form}
        </div>
        {title !== "Payments" && <div className="col-md-4 text-end">
          <div className="d-flex justify-content-end">
            <div className="view-options my-3 mx-2 pt-1">{title}</div> {
              gridView && (
                <RadioGroupInput
                  name="view"
                  options={options}
                  defaultValue={options[0].value}
                  handleChange={handleChange}
                  value={view}
                />
              )
            }
          </div>
        </div>}
      </div>)}

      {table.data ? (
        <>
          <div className="scrollbar" id="style-4">
            <div className={`view-wrapper ${lang === 'ar' ? 'ml-4' : 'mr-4'}`} id="view-wrapper">
              {view === "list" ? (
                <>
                  <BasicTable {...table} programs={programs} />
                </>
              ) : (
                <div className="row">{gridView()}</div>
              )}
            </div>
          </div>
          { pagination && <PaginationComponent {...pagination} /> }
        </>
      ) : (
        null
      )}
    </div>
  );
};

export default injectIntl(TableGridView);
